import React, { useEffect, useRef, useState } from "react";

import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { sendEmails, loadEmail } from "../utils/Network";
import SelectTalent from "../components/SelectTalent";
export default function EmailContent({ id }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [to, setTo] = useState(null);
  const [subject, setSubject] = useState(null);
  const [message, setMessage] = useState("");
  const [talent, setTalent] = useState(null);

  const inputFileRef = useRef(null);
  useEffect(() => {
    if (id) {
      loadEmail(id).then((email) => {
        setTo(email.to);
        setSubject(email.subject);
        setMessage(email.message);
      });
    }
  }, []);

  const handleTalentSelect = (value, name) => {
    setTalent(value);
  };

  const onChange = (e) => {
    //alert(e.target.name)
    switch (e.target.name) {
      case "subject":
        setSubject(e.target.value);
        break;
      case "to":
        setTo(e.target.value);
        break;
      case "message":
        setMessage(e.target.value);
        break;

      default:
        break;
    }
  };
  const handleDescriptionChange = (data) => {
    setMessage(data);
  };

  const SaveChanges = () => {
    setError(null);

    if (!to && !talent) {
      setError("Please enter emails or select a talent");
      return;
    }

    if (!subject) {
      setError("Please enter subject");
      return;
    }

    if (!message) {
      setError("Please enter message");
      return;
    }

    var emails = [];
    
    if(to) emails = to.split(",");

    setLoading(true);
    sendEmails(emails,talent, subject, message).then((data) => {
      console.log(data);

      setLoading(false);
    });
  };

  return (
    <>
      <div className="content-wrapper">
        <section className="content-header">
          <h3 className="box-title mb-10"></h3>
          <ol className="breadcrumb">
            <li>
              <a href="/cms">
                <i className="fa fa-dashboard"></i> Home
              </a>
            </li>
            <li className="active">Settings </li>
            <li className="active">General </li>
          </ol>
        </section>

        <section className="content padding-top-sm-0">
          <div className="row">
            <div className="col-md-8">
              <div className="box">
                <div className="box-header">Send Email</div>
                <div className="box-body padding-10">
                  <div className="form-group">
                    <input
                      type="text"
                      value={to}
                      name="to"
                      onChange={onChange}
                      className="form-control "
                      placeholder="To"
                    />
                  </div>
                  <div className="form-group">
                    <SelectTalent
                      value={talent}
                      border={"1"}
                      width={"225px"}
                      callback={handleTalentSelect}
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="text"
                      value={subject}
                      name="subject"
                      onChange={onChange}
                      className="form-control post-title"
                      placeholder="Subject"
                    />
                  </div>
                  <div className="form-group mb-15">
                    <div className="form-group">
                      <CKEditor
                        editor={ClassicEditor}
                        data={message}
                        onReady={(editor) => {
                          // You can store the "editor" and use when it is needed.
                        }}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          handleDescriptionChange(data);
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className="box-footer">
                  <button
                    className="btn btn-primary pull-right"
                    onClick={SaveChanges}
                  >
                    Send Emails
                  </button>
                  <a href={`emails`} className="btn btn-default pull-left">
                    Cancel
                  </a>
                </div>
              </div>
              {error && <div className="alert alert-danger mt-5">{error}</div>}
              {loading && (
                <div className="alert alert-info  mt-5">Please Wait...</div>
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
